import React from "react";
import {PROJECTS, PUBLIC_RFTS, MAIN_PAGE} from "constants/routes.const";
import {Link} from "react-router-dom";

// isStatic: the logo is only a picture, for pages with nowhere to go (the waiting page)
const Logo = ({activeLogo, isBuyer, isPublic, isStatic}) => {
  if (isStatic)
    return (
      <div className="header__logo-wrapper">
        {activeLogo ? (
          <img src={activeLogo} alt="" height="41" />
        ) : (
          <div className="header__logo __static" />
        )}
      </div>
    );

  return (
    <div className="header__logo-wrapper">
      {activeLogo ? (
        <Link to={isBuyer ? PROJECTS : PUBLIC_RFTS}>
          <img src={activeLogo} alt="" height="41" />
        </Link>
      ) : (
        <Link
          to={isPublic ? MAIN_PAGE : isBuyer ? PROJECTS : PUBLIC_RFTS}
          className="header__logo"
        />
      )}
    </div>
  );
};

export default Logo;
